import React, { useState } from "react";
import { HiChevronDown, HiChevronUp } from "react-icons/hi";

const AccordionItem = ({ title, children, isOpen, onToggle }) => (
  <div className="mb-3">
    <button
      onClick={onToggle}
      className="w-full text-left px-5 py-3 bg-gray-100 font-medium text-sm text-gray-700 flex justify-between items-center rounded-md"
    >
      {title}
      <span className="text-gray-600 text-xl">
        {isOpen ? <HiChevronUp /> : <HiChevronDown />}
      </span>
    </button>
    {isOpen && <div className="p-5">{children}</div>}
  </div>
);

const PersonalInformation = ({ data, loading }) => {
  const [openAccordion, setOpenAccordion] = useState("Basic Information");

  const toggleAccordion = (section) => {
    setOpenAccordion(openAccordion === section ? null : section);
  };

  if (!data && !loading) {
    return (
      <div className="flex items-center justify-center h-[600px] w-full text-gray-500 text-base">
        Please search by Patient ID
      </div>
    );
  }

  if (loading) {
    return <div className="p-8 text-gray-500">Loading patient info...</div>;
  }

  if (!data || !data.successObject?.patientDetails) {
    return <div className="p-8 text-red-500">No patient data found.</div>;
  }

  const patient = data.successObject.patientDetails;
  const addresses = data.successObject.addressDetails || [];

  const basicInfoFields = [
    {
      label: "Full Name",
      value: `${patient.salutation || ""} ${patient.firstName || ""} ${
        patient.lastName || ""
      }`.trim(),
    },
    { label: "Patient ID", value: patient.code || "NA" },
    { label: "Mobile Number", value: patient.mobile || "NA" },
    { label: "Email ID", value: patient.email || "NA" },
    { label: "Gender", value: patient.gender || "NA" },
    {
      label: "DOB",
      value: patient.dob
        ? new Date(patient.dob).toLocaleDateString("en-IN")
        : "NA",
    },
  ];

  return (
    <div className="w-full p-3 sm:p-8 mx-auto">
      <AccordionItem
        title="Basic Information"
        isOpen={openAccordion === "Basic Information"}
        onToggle={() => toggleAccordion("Basic Information")}
      >
        <div className="divide-y">
          {basicInfoFields.map((item, index) => (
            <div
              key={index}
              className="grid grid-cols-2 items-center py-3 gap-x-2"
            >
              <div className="text-sm font-medium text-gray-500">
                {item.label}
              </div>
              <div className="text-sm font-semibold text-black break-words min-w-0">
                {item.value}
              </div>
            </div>
          ))}
        </div>
      </AccordionItem>

      {addresses.length > 0 && (
        <AccordionItem
          title="Address"
          isOpen={openAccordion === "Address"}
          onToggle={() => toggleAccordion("Address")}
        >
          <div className="divide-y">
            {addresses.map((address, index) => {
              const fullAddress = [address.address1, address.address2]
                .filter(Boolean)
                .join(", ");

              return (
                <div
                  key={index}
                  className="grid grid-cols-2 items-center py-3 gap-x-2"
                >
                  <div className="text-sm font-medium text-gray-500">
                    Address {index + 1}
                    {address.isDefault === 1 && (
                      <span className="text-green-500 text-sm font-semibold px-[3%] py-1 ml-2">
                        Default
                      </span>
                    )}
                  </div>

                  <div className="text-sm font-semibold text-black flex items-center gap-2">
                    <span>{fullAddress}</span>
                  </div>
                </div>
              );
            })}
          </div>
        </AccordionItem>
      )}
    </div>
  );
};

export default PersonalInformation;
